RivalIQ.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    function parseInformation(info) {

        if (!info || _.isString(info)) {

            return {
                content: info
            };
        }

        if (!_.isElement(info) && _.isObject(info)) {

            return info;
        }

        const nodes = $(info);

        return {
            title: nodes.find('.information-title'),
            content: nodes.find('.information-content')
        };
    }

    behaviors.Information = Marionette.Behavior.extend({
        ui: {
            information: '.fa-info-circle'
        },

        defaults: {
            trigger: 'hover',
            placement: 'auto right',
            container: 'body'
        },

        initializePopover: function () {

            const me = this;
            const options = me.options;

            const information = parseInformation(options.information || me._getConfig());

            if (!information.content) {
                return me.ui.information.popover({
                    trigger: options.trigger,
                    placement: options.placement,
                    container: options.container
                });
            }

            me.ui.information.show();

            me.ui.information.popover({
                html: true,
                title: information.title,
                content: information.content,
                trigger: options.trigger,
                placement: options.placement,
                container: options.container
            });
        },

        _getConfig: function () {
            const me = this;
            if (me.options.selector) {
                return me.$(me.options.selector)[0];
            }

            return _.result(me.view.model.toJSON(), 'information');
        },

        onInfoDestroy: function () {
            const me = this;
            if (me.view.isRendered) {
                me.ui.information.popover('destroy');
            }
        },

        onBeforeDestroy: function () {
            const me = this;
            me.onInfoDestroy();
        },

        onRender: function () {
            const me = this;
            me.initializePopover();
        }
    });
});
